/**
 * Returns the correct redirect path based on a user's application status and current step.
 * Used after login and registration to send users to the right place.
 */
export function getRedirectPath(applicationStatus, currentStep) {
  if (!applicationStatus || applicationStatus === 'not_started') {
    return '/apply';
  }
  if (applicationStatus === 'in_progress') {
    return `/apply?step=${currentStep || 1}`;
  }
  // submitted or any later stage — go to dashboard
  return '/dashboard';
}
